module.exports = __webpack_public_path__ + "img/13.be05cb09.jpg";